<div class="page-cloudtarget">
  <div class="layout-detail-block" :class="{'style--no-data': state.dataList.length === 0}">
    <div class="tabHeader">
      <div class="select-block">
        <Select :options="options.options" v-model:selected="options.selected" @onChange="onChangeFilter"></Select>
      </div>
      <div class="buttonGroup">
        <Button type="full" class="btn-inline" colors="dark1" theme="2" wd="sm"
        :text="t('__common.__import')" h="mlg" @onClick="importTarget"></Button>
        <Button type="full" class="btn-inline" colors="dark1" theme="2" wd="sm"
        :text="t('__common.__export')" h="mlg" @onClick="exportTarget" :disable="isBtnDelDiable"></Button>
        <Button type="full" class="btn-inline" colors="dark1" theme="2" wd="sm" icon="asus_proart_sw_ico_delete"
        :text="t('__g3p_m8t.__delete')" h="mlg" :disable="isBtnDelDiable" @onClick="delTarget"></Button>
      </div>
    </div>

    <div class="tabMainBlock h--full">
      <Table @tableSort="tableSort" @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow" @onCheckEach="onCheckEach"
        :columns="column" :data="state.dataList" tablePadding="20" dropdown="dataInfo" :checkBox="true">
        <template #second="{index, data}">
          <TableInfo :data="data.dataInfo" :totalCol="column.length"
            :columns="setAppListColSub(data.dataInfo[0])">
          </TableInfo>
        </template>
        <template #empty="{text}">
          <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
        </template>
      </Table>
    </div>
  </div>
  <!-- <div>
    {{state.list}}
  </div> -->
  <div class="tabFooter" v-if="pages.totalPage">
    <Pagination :totalPage="pages.totalPage" :input="true" position="start" :nowPage="pages.current" :range="5"
      @changePage="changePage"></Pagination>
  </div>
</div>